import * as React from 'react';
import { StateFilter } from '../../../../../../Machine';
import { Suspended } from '../../../../../../Suspended';
import { LazyInvestmentGoalsQuestionnaireStep } from '../../../questionnaires/InvestmentGoalsQuestionnaire';
import { StepContainer } from '../../../utils/Step';
import { CommonInvestmentGoalsExclusions } from '../../shared';
import { GestionInvetmentGoalsExclusions } from './exclusions';
import { BackToServiceSelection } from '../../../directNavigation/backToServiceSelection';

export const GestionInvestmentGoals = () => (
  <>
    <StateFilter is=".questions">
      <Suspended>
        <LazyInvestmentGoalsQuestionnaireStep />
      </Suspended>
    </StateFilter>
    <StateFilter is=".exclusions">
      <StepContainer>
        <CommonInvestmentGoalsExclusions />
        <GestionInvetmentGoalsExclusions />
        <BackToServiceSelection />
      </StepContainer>
    </StateFilter>
  </>
);
